import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  networkWrap: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '7px',
    paddingBottom: '7px',
  },

  networkWrap: {
    ':not(:last-of-type)': {
      marginRight: '10px',
    },
  },
});

export default styles;
